import React from 'react';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionMessage from '../shared/SectionMessage';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { SectionProps } from '../types';
import HowToFix from '../shared/HowToFix';
import WebVitalChart from '../shared/WebVitalChart';

export default function LargestContentfulPaintSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {result.duration && (
                    <WebVitalChart
                        markerAt={parseFloat((result.duration / 1000).toFixed(2))}
                        maxGoodVal={2.5}
                        minPoorVal={4}
                        unitsSuffix={' s'}
                    />
                )}

                {(result.node || result.text) && (
                    <div className={`result-meta ${result.status}`}>
                        <div className="title">Largest Contentful Paint element within the viewport:</div>

                        {result.text && result.node && (
                            <div>
                                <strong>Text: </strong>
                                {result.text}
                            </div>
                        )}

                        {result.text && !result.node && <em>{result.text}</em>}

                        {result.text && result.node && (
                            <div>
                                <strong>Html: </strong>
                                <em>
                                    <span dangerouslySetInnerHTML={{ __html: result.node }} />
                                </em>
                            </div>
                        )}

                        {!result.text && result.node && <em dangerouslySetInnerHTML={{ __html: result.node }} />}
                    </div>
                )}

                {result.how_to_fix && (
                    <HowToFix
                        title={title}
                        howToFix={result.how_to_fix}
                        howToFixVideo={result.how_to_fix_video}
                    />
                )}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}
